import { type TextFieldProps } from '@mui/material/TextField';
import { MuiTelInput, type MuiTelInputProps } from 'mui-tel-input';
import { type FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type TProps = Omit<TextFieldProps, 'name' | 'onChange' | 'value'> & {
  name: string;
  /**
   * Fallback country used when the typed dial code is ambiguous (e.g. `+1` is
   * shared by all NANP countries, so AsYouType can't pick one until more digits
   * are typed). Unique prefixes like `+880` still resolve to the right country
   * automatically.
   */
  defaultCountry?: MuiTelInputProps['defaultCountry'];
};

export const RHFPhoneInput: FC<TProps> = ({ name, helperText, label, placeholder, defaultCountry = 'US', ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <MuiTelInput
          {...rest}
          value={field.value ?? ''}
          onChange={value => field.onChange(value)}
          onBlur={field.onBlur}
          inputRef={field.ref}
          defaultCountry={defaultCountry}
          fullWidth
          label={label}
          placeholder={placeholder ?? '+1 555 123 4567'}
          error={!!error}
          helperText={error ? error.message : (helperText ?? 'Start with a country code (e.g. +1, +44, +880)')}
        />
      )}
    />
  );
};
